// Add your custom JS here.

	(function ($) {
	  var lastScrollTop = 0,
	    delta = 50;
	  $(window).scroll(function () {
	    var nowScrollTop = $(this).scrollTop();
	    if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
	      if (nowScrollTop > lastScrollTop) {
	        $("#wrapper-navbar").addClass("scrolled-down");
	        $("#wrapper-navbar").removeClass("scrolled-up");
	      } else {
	        $("#wrapper-navbar").addClass("scrolled-up");
	        $("#wrapper-navbar").removeClass("scrolled-down");
	      }
	      lastScrollTop = nowScrollTop;
	    }
	  });
	  $(window).on("resize scroll", function () {
	    if ($(window).scrollTop() < 50) {
	      $("#wrapper-navbar").removeClass("scrolled-up");
	    }
	  });


	  $('.dropdown-menu').prepend('<a class="nav-link sub__close" href="#"> Powrót</a>');
	  $(".sub__close").on("click", function () {
	    $(".dropdown-menu").hide();
	  });

	    /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function() {
        $('.case').each(function(){
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() < 1199) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            }
            else{
                if (!$carousel.hasClass('slick-initialized')) {
                    $carousel.slick({
                        infinite: false,
			            slidesToShow: 2,
			            variableWidth: true,
			            slidesToScroll: 1,
			            autoplay: false,
			            centerMode: false,
			            touchThreshold: 1000,
			            swipeToSlide: false,
			            nextArrow: '.carousel-next',
	                    prevArrow: '.carousel-prev'

                    });
                }
            }
        });
    });

$(document).ready(function () {
    // Ukryj wszystkie taby i pokaż pierwszy
    $('.tab-content').hide();
    $('.tab-content:first').show();

    // Dodaj klasę 'active' do pierwszego przycisku
    $('.tabs-nav .wp-block-button:first').addClass('active');

    // Obsługa kliknięcia w przycisk
    $('.tabs-nav .wp-block-button__link').click(function () {
        // Usuń klasę 'active' z aktualnego aktywnego przycisku
        $('.tabs-nav .wp-block-button').removeClass('active');

        // Dodaj klasę 'active' do rodzica klikniętego przycisku
        $(this).closest('.wp-block-button').addClass('active');

        // Wyświetl odpowiednią zawartość tabów
        let currentTab = $(this).attr('href');
        $('.tab-content').hide();
        $(currentTab).fadeIn();

        return false; // Zapobiegnij domyślnemu działaniu linka
    });
});

	const details = document.querySelectorAll('details')

function close_slblings(event) {
  event.stopPropagation()
  for (let sib of this.parentElement.querySelectorAll(':scope > details'))
    if (sib != this)
      sib.removeAttribute('open')
      // optionally recursively close their children details
}

for (let el of details) {
  el.addEventListener('click',close_slblings)
}




	})(jQuery);